module.exports = __webpack_public_path__ + "static/artist-development-the-process-c3adeee44cb077dc93f8ce9d8681a6dd.webp";